<template>
	<div class='user-manage-log-wrap'>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane v-for="tab in tabList" :key="tab.name" :label="tab.label" :name="tab.name">
			</el-tab-pane>
		</el-tabs>
		<div class="user-manage">
			<template v-for="item in list.data">
				<div class="manage-item" :key="item.dataId">
					<img :src="getImgurl(item.dataType)">
					<div class="card-item">
						<p class='c-time'>{{ item.pointTime }}</p>
						<div class='card-con'>
							<div :class="['leftTit',getClass(item.dataType)]">{{ manageDataType[item.dataType] }}</div>
							<div class="rigCon">
								<h2>
									<b>{{ item.description }}</b>
									<p>
										<el-tag effect="plain"
											v-if="item.autoState!=null">{{ '自动提醒'+smsAutoState1[item.autoState].label }}</el-tag>
										<el-tag effect="plain"
											v-if="item.manualState!=null">{{ '人工提醒'+manualState1[item.manualState].label }}</el-tag>
									</p>
								</h2>
								<p class='dep-look'>
									<span>{{ item.department }}</span>
									<span @click='toDetail(item)'>查看</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';

export default {
	mixins: [mixin],
	props: {
		patientId: { required: true }
	},
	watch: {
		patientId(newV, oldV) {
			if (newV && (newV != oldV)) {
				this.init();
			}
		}
	},
	data() {
		return {
			noSidebar: true,
			filter: {
				dataType: null,
				pageNumber: 1,
				pageSize: 10,
				patientId: null
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			activeName: 'all', // 默认选中“全部”
			tabList: [
				{ label: '全部', name: 'all' },
				{ label: '就诊管理', name: 'visit' },
				{ label: '随访管理', name: 'followup' },
				{ label: '复诊管理', name: 'revisit' }
			],
			dataStateMap: [
				{
					dataType: 0,
					label: '就诊管理',
				},
				{
					dataType: 1,
					label: '就诊管理',
				},
				{
					dataType: 2,
					label: '就诊管理',
				},
				{
					dataType: 3,
					label: '随访管理',
				},
				{
					dataType: 4,
					label: '复诊管理',
				},
			],
			manageDataType: {
				0: '院中',
				1: '出院',
				2: '门诊',
				3: '随访',
				4: '复诊',
			},
			manualState1:[
				{
					value: '0',
					label: '[待]',
				},
				{
					value: '1',
					label: '[已]',
				},
				{
					value: '2',
					label: '[已]',
				},
				{
					value: '3',
					label: '[已]',
				}
			],
			smsAutoState1:[
				{
					value: '0',
					label: '[待]',
				},
				{
					value: '1',
					label: '[已]',
				},
				{
					value: '2',
					label: '[失败]',
				},
				{
					value: '3',
					label: '[失败]',
				},
				{
					value: '4',
					label: '[失败]',
				},
			]

		}
	},
	created() {
		// this.setTab('')
		if (this.patientId) { this.init(); }
		this.$nextTick(()=>{
				this.handleTabClick({index:0})
			})
	},
	methods: {
		
		getImgurl(datatype) {
			switch (datatype) {
				case 0:case 1:case 2:
					return require("@/assets/images/log-menzhen.png");
				case 3:
					return require("@/assets/images/log-follow.png");
				case 4:
					return require("@/assets/images/log-revisit.png");
				
			}
		},
		getClass(datatype){
			switch (datatype) {
				case 0:case 1:case 2:
					return 'left-outpatient';
				case 3:
					return 'left-follow';
				case 4:
					return 'left-revisit';
			}
		},
		init() {
			this.filter.patientId = this.patientId;
			api.getListPatientTreeTimeline(this.filter).then((res) => {
				if (res.code == 1000 && res.data) {
					this.list.data = res.data;
				}
			});
			
		},
		handleTabClick(tab) {
			
			this.$nextTick(() => {
				const tabs = this.$el.querySelectorAll('.el-tabs__item'); // 所有 tab
				const activeBar = this.$el.querySelector('.el-tabs__active-bar'); // 下划线
				const currentTab = tabs[Number(tab.index)]; // 当前 tab
				const tabLeft = currentTab.offsetLeft;
				const tabWidth = currentTab.offsetWidth;
				const barWidth = activeBar.offsetWidth;

				const offset = tabLeft + (tabWidth - barWidth) / 2;
				
				activeBar.style.transform = `translateX(${offset}px)`;
			});
		},
		handleClick(tab, event) {
    this.activeName = tab.name; // 先更新 v-model

    this.$nextTick(() => {      // 等 DOM 更新完
        this.handleTabClick(tab);

        switch(tab.name){
            case 'all': this.filter.dataType = null; break;
            case 'visit': this.filter.dataType = 1; break;
            case 'followup': this.filter.dataType = 3; break;
            case 'revisit': this.filter.dataType = 4; break;
        }

        this.init();
    });
},
		toDetail(item){
			let query;
			switch(item.dataType){
				case 0:
					query = {
							patientId:this.patientId,
							t:3,
							fid:item.recordId,
							datasources:item.datasources,
							t2:1,
							id:item.dataId
						}
						break;
				case 1:case 2:
					if(item.dataState==1){
						query = {
							patientId:this.patientId,
							t:3,
							fid:item.recordId,
							datasources:item.datasources,
						}
					}else{
						query = {
							patientId:this.patientId,
							t:3,
							fid:item.recordId,
							datasources:item.datasources,
							t2:2,
							id:item.dataId
						}
					}
					break;
				case 3:
					query = {
						patientId:this.patientId,
						t:5,
						date:item.expectFollowupDate,
						followupId:item.dataId
					}
					break;

				case 4:
					query = {
						patientId:this.patientId,
						t:3,
						fid:item.recordId,
						datasources:item.datasources,
						t2:3
					}
					break;

			}
			this.$router.push({name:'Patient/User',query: query}).then(() => {
				window.location.reload();
			});
		}

	}
}
</script>

<style lang="less" scoped>
@import './user-bio.less';
h2,p{
	margin:0 !important;
}

.rigCon{
	::v-deep .el-tag{
		font-size: 10px !important;
		font-weight: 500;
		height: auto;
		line-height: normal;
		padding: 1px 7px 2px;
		border-radius: 10px;
		margin-right:8px;
	}
}
</style>
